
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/complaints-procedure",
      function () {
        return require("private-next-pages/complaints-procedure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/complaints-procedure"])
      });
    }
  